import type VueI18n from 'vue-i18n/types';

interface TFunctionOverloads {
    (key: string, values?: VueI18n.Values | undefined): string;
    (key: string, locale: string, values?: VueI18n.Values | undefined): string;
}

export const I18nService = Symbol('I18nService');

export interface I18nService {
    locale: VueI18n['locale'];
    t: TFunctionOverloads;
    te: VueI18n['te'];
}
